<template>
  <div class="base-locked-symbol-circle">
    <img class="lock-icon" src="@/assets/img/lock.svg">
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.base-locked-symbol-circle {
  position: relative;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 3rem;
  height: 3rem;
  border-radius: 100%;
  background-color: rgba(255, 255, 255, 0.1);
}
.lock-icon {
  position: absolute;
  display: block;
  width: 35%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
